import { actions } from '@grandvisionhq/state';

const add = actions.action('products/prescription-glasses/add-to-cart');
const addSuccess = actions.action('products/prescription-glasses/add-to-cart-success');
const addFailed = actions.action('products/prescription-glasses/add-to-cart-failed', (error)=>({
        error
    })
);

export { add, addFailed, addSuccess };
//# sourceMappingURL=actions.js.map
